import moment from "moment-timezone";
import {
  formatDistanceStrictWithOptions,
  differenceInMinutes,
} from "date-fns/fp";
import { enUS } from "date-fns/locale";
function formatArticleDate(dateString) {
  var userTimezone = moment.tz.guess();
  var normalizedDate = `${dateString.replace(" ", "T")}:00Z`;

  return (
    moment(normalizedDate).tz(userTimezone).format("lll") +
    " " +
    moment.tz(normalizedDate, userTimezone).zoneAbbr()
  );
}

// REMEMBER all storyblok dates are UTC
function DateToStoryblokQueryableDateString(d) {
  return moment(d).format("YYYY-MM-DD HH:MM");
}

const stringToDate = (str) => new Date(str.replace(/\s+/, "T"));

const distanceInWordsFromNow = (date) =>
  formatDistanceStrictWithOptions(
    {
      addSuffix: true,
      locale: enUS,
    },
    Date.now(),
    date
  );

const distanceInMinutesFromNow = (date) =>
  differenceInMinutes(Date.parse(date), Date.now());

export {
  formatArticleDate,
  DateToStoryblokQueryableDateString,
  stringToDate,
  distanceInWordsFromNow,
  distanceInMinutesFromNow,
};
